import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

interface Props {
    fromDate: Date | null;
    toDate: Date | null;
    onChangeFrom: (date: Date | null) => void;
    onChangeTo: (date: Date | null) => void;
    onApply: () => void;
    onClear: () => void;
    maxDate?: Date; // optional restriction
    showTitle?: boolean;
}

const DateFilterBar: React.FC<Props> = ({
    fromDate,
    toDate,
    onChangeFrom,
    onChangeTo,
    onApply,
    onClear,
    maxDate,
    showTitle = true
}) => {

    const [error, setError] = useState<string | null>(null);

    const validate = (): boolean => {
        if (!fromDate || !toDate) {
            setError("Both From and To dates are required.");
            return false;
        }

        if (fromDate > toDate) {
            setError("From date cannot be later than To date.");
            return false;
        }

        if (maxDate && toDate > maxDate) {
            setError("Future dates are not allowed.");
            return false;
        }

        setError(null);
        return true;
    };

    const handleApply = () => {
        if (validate()) {
            onApply();
        }
    };



    return (
        <>
          <div className="flex justify-content-end align-items-end mb-3 w-full flex-wrap gap-3">

                <div className="flex align-items-end gap-2 flex-wrap">

                    <div className="flex flex-column">
                        <label className="text-sm text-600 mb-1">From</label>
                        <Calendar
                            value={fromDate}
                            onChange={(e) => {
                                onChangeFrom(e.value as Date);
                                setError(null);
                            }}
                            dateFormat="yy-mm-dd"
                            showIcon
                            maxDate={toDate || maxDate}
                            inputClassName="p-inputtext w-12rem"
                        />
                    </div>

                    <div className="flex flex-column">
                        <label className="text-sm text-600 mb-1">To</label>
                        <Calendar
                            value={toDate}
                            onChange={(e) => {
                                onChangeTo(e.value as Date);
                                setError(null);
                            }}
                            dateFormat="yy-mm-dd"
                            showIcon
                            minDate={fromDate || undefined}
                            maxDate={maxDate}
                            inputClassName="p-inputtext w-12rem"
                        />
                    </div>

                    <Button
                        label="Apply"
                        icon="pi pi-check"
                        disabled={!fromDate || !toDate}
                        onClick={handleApply}
                    />

                </div>
            </div>

            {error && (
                <div className="p-2 mb-3 border-round bg-red-50 text-red-600 text-sm">
                    {error}
                </div>
            )}
        </>
    );
};

export default DateFilterBar;